import type {
  JsonPayload,
  JsonTransactionContract,
} from "@core/ports/json-storage";
import { BaseJsonRepository } from "@core/ports/json-storage";
import type { ZodObject, ZodReadonly, ZodType } from "@core/zod";

import type { DeviceStorageManager } from "./DeviceStorageManager.ts";

export abstract class BaseDeviceRepository<
  Identifier extends ZodObject,
  Data extends ZodObject,
  Payload extends JsonPayload<Identifier, Data>,
  EntityType extends string,
> extends BaseJsonRepository<
  Identifier,
  Data,
  Payload,
  JsonTransactionContract,
  EntityType
> {
  protected constructor({
    dataSchema,
    deviceStorage,
    entityType,
    identifierSchema,
    readSchema,
    resourceName,
    tableName,
  }: {
    readonly dataSchema: ZodReadonly<Data>;
    readonly deviceStorage: DeviceStorageManager;
    readonly entityType: EntityType;
    readonly identifierSchema: ZodReadonly<Identifier>;
    readonly readSchema: ZodType<JsonPayload<Identifier, Data>>;
    readonly resourceName: string;
    readonly tableName: string;
  }) {
    super({
      dataSchema,
      db: deviceStorage.createRepositoryHelper<Identifier, Data, EntityType>({
        entityType,
        readSchema,
        tableName,
      }),
      entityType,
      identifierSchema,
      resourceName,
    });
  }
}
